var React = require('react');

function MenuIconClose (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"Close"),React.createElement("desc",{"key":1},"Created with Sketch."),React.createElement("g",{"id":"Components","stroke":"none","strokeWidth":"1","fill":"none","fillRule":"evenodd","key":2},React.createElement("g",{"id":"Close","transform":"translate(1.000000, 1.000000)","stroke":"#002B38","strokeWidth":"2.5"},[React.createElement("path",{"d":"M1.77635684e-15,1.42108547e-14 L19.4454365,19.4454365","id":"Line-3","key":0}),React.createElement("path",{"d":"M3.55271368e-15,1.33226763e-14 L19.4454365,19.4454365","id":"Line-3","transform":"translate(9.722718, 9.722718) scale(-1, 1) translate(-9.722718, -9.722718) ","key":1})]))]);
}

MenuIconClose.defaultProps = {"width":"20px","height":"22px","viewBox":"0 0 22 22","version":"1.1"};

module.exports = MenuIconClose;

MenuIconClose.default = MenuIconClose;
